// extracted by mini-css-extract-plugin
module.exports = {"title":"SponsorshipsHero_title__I43is"};